/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindViewByIdQueryResponse,
  FindViewByIdPathParams,
} from "../types/FindViewById.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findViewByIdQueryKey = (
  id: FindViewByIdPathParams["id"] | undefined
) => [{ url: "/v1/view/find-view-by-id/:id", params: { id: id } }] as const

export type FindViewByIdQueryKey = ReturnType<typeof findViewByIdQueryKey>

/**
 * @summary Find view by id
 * {@link /v1/view/find-view-by-id/:id}
 */
export async function findViewById(
  id: FindViewByIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindViewByIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/view/find-view-by-id/${id}`, ...requestConfig })
  return res
}

export function findViewByIdQueryOptions(
  id: FindViewByIdPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findViewByIdQueryKey(id)
  return queryOptions<
    ResponseConfig<FindViewByIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindViewByIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return findViewById(id!, { ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary Find view by id
 * {@link /v1/view/find-view-by-id/:id}
 */
export function useFindViewById<
  TData = ResponseConfig<FindViewByIdQueryResponse>,
  TQueryData = ResponseConfig<FindViewByIdQueryResponse>,
  TQueryKey extends QueryKey = FindViewByIdQueryKey,
>(
  id: FindViewByIdPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindViewByIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findViewByIdQueryKey(id)

  const query = useQuery(
    {
      ...findViewByIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
